import moment from 'moment-timezone';
import React, { FC } from 'react';

import { Button, ButtonProps } from '../../../Button';
import { Tag, TagColorEnum } from '../../../Tags/Tags';
import { Text } from '../../../Text';
import './ClassServiceListItem.scss';

export interface ClassServiceViewModel {
  start: string;
  end: string;
  students: string[];
  title: string;
  content: string;
  id?: string;
}

export interface ClassServiceListItemProps {
  service: ClassServiceViewModel;
  actions?: ButtonProps[];
  isLoading?: boolean;
}

export const ClassServiceListItem: FC<ClassServiceListItemProps> = props => {
  const { actions, service } = props;
  const actionButtons = actions?.map((action, index) => (
    <Button {...action} key={index} appearance="transparent" />
  ));
  const students = service.students.map((student, index) => (
    <Tag key={index} color={TagColorEnum.Grey} label={student} />
  ));
  const timeFormat = 'DD.MM.';
  return (
    <li className="classServiceListItem" tabIndex={0}>
      <div className="flex items-center gap-4">
        <div className="flex flex-col items-center gap-2">
          <Text weight="bold" size="lg">
            {moment(service.start).format(timeFormat)}
          </Text>
          <Text weight="bold" size="lg">
            {moment(service.end).format(timeFormat)}
          </Text>
        </div>
        <div className="flex flex-col flex-1 gap-1">
          <Text weight="bold" size="lg">
            {service.title}
          </Text>
          <div className="flex flex-wrap gap-2">{students}</div>
          <Text>{service.content}</Text>
        </div>
        <div className="flex gap-2">{actionButtons}</div>
      </div>
    </li>
  );
};
